export default "__VITE_ASSET__rVdAoqKc__"